import { Stack } from '@mui/material';
import { StyledTextField } from 'modules/components/layer01';
import {
  PlanSetSelectField,
  UploadPlanVersionField
} from 'modules/components/layer04';
import { FormBaseLayout } from 'modules/components/layer10';
import React from 'react';
import * as ds from './dataService';
import _ from 'lodash';
import { SavePlan_Input } from 'generated/graphql';


export type SavePlanFormProps = {
  id: string;
  versionOnly?: boolean;
  installationId?: string;
  projectId?: string;
  handleClose: () => void;
};



/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: SavePlanFormProps) => {

  const form = ds.useFormState(props.id);

  const [
    fnSavePlan,
    { loading }
  ] = ds.useSavePlanForm();

  const handleSubmit = async (projectId: string, installationId: string, formState: ds.IFormState) => {
    const isCreate = _.isNull(formState.id) || formState.id === '' ? true : false;
    let input: SavePlan_Input;

    if (isCreate) {
      input = {
        projectId,
        installationId,
        name: formState.name,
        planSetId: formState.planSetId,
        planVersion: {
          apiFileId: formState.planVersionId,
          name: formState.planVersionName
        }
      };
    } else {
      input = {
        id: formState.id,
        name: formState.name,
        planSetId: formState.planSetId,
        planVersion: {
          apiFileId: formState.planVersionId,
          name: formState.planVersionName
        }
      };
    }

    if (_.isNil(formState.planVersionId)) {
      delete input.planVersion;
    }
    if (_.isNil(formState.installationId)) {
      _.unset(input, 'installationId');
    }

    await fnSavePlan({
      ...input
    });

    props.handleClose();
  };

  return (
    <FormBaseLayout.FC
      handleCancel={() => props.handleClose()}
      handleSubmit={() => handleSubmit(props.projectId ?? '', props.installationId ?? '', form.formState)}
      isLoading={loading}
    >
      <Stack
        rowGap='1.5rem'
      >
        {
          props.id && props.versionOnly
            ? (
              <>
                <UploadPlanVersionField.FC
                  form={form}
                  fieldName='planVersionId'
                />
                <StyledTextField.FC
                  {...form.genFieldProps('planVersionName')}
                />
              </>
            )
            : props.id
              ? (
                <>
                  <StyledTextField.FC
                    {...form.genFieldProps('name')}
                  />
                  <PlanSetSelectField.FC
                    form={form}
                    fieldName='planSetId'
                  />
                </>
              )
              : (
                <>
                  <StyledTextField.FC
                    {...form.genFieldProps('name')}
                  />
                  <PlanSetSelectField.FC
                    form={form}
                    fieldName='planSetId'
                  />
                  <UploadPlanVersionField.FC
                    form={form}
                    fieldName='planVersionId'
                  />
                  <StyledTextField.FC
                    {...form.genFieldProps('planVersionName')}
                  />
                </>
              )
        }
      </Stack>
    </FormBaseLayout.FC>
  );
};
